import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ApplyNowContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading : 1,
            name:'',
            email:'',
            phone:'',
            city:'',
            file:null,
            fileKey:Date.now(),
            errors:{},
            fopen:false,
            success_message:'',
            reg_error:false,
            err_message:"",
            sending:false
        }
        

    }

 
    componentDidMount()
    {
         this.setState({loading:0});
        
    }
     handleSubmit = (event) => {
        event.preventDefault();
        const errors = {};
        if (!this.state.name) {
            errors.name = 'Name is required';
          }  
          if (!this.state.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.email)) {
          errors.email = 'Invalid email';
        }
        if (!this.state.phone) {
            errors.phone = 'Phone number is required';
          }  
         
        if (Object.keys(errors).length > 0) {
          this.setState({ errors });
        } else {
            this.setState({sending:true});
            const data = new FormData();
            data.append('name', this.state.name);
            data.append('email', this.state.email);
            data.append('phone', this.state.phone);
            data.append('city', this.state.city);
            data.append('file', this.state.file);
            axios.post(api_base_url+"send_career", data, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }}).then(response=>{

                if(response.data.error)
                {
                    this.setState({reg_error:true});
                    this.setState({fopen:false});
                    this.setState({err_message: response.data.message});  
                }
                else{
                    
                    this.setState({fopen:true});
                    this.setState({reg_error:false});
                    this.setState({success_message:" Application has been successfully sent."});
                    this.setState({name:'',email:'', phone:'',city:'',file:null,fileKey:Date.now(), sending:false}); 
                }
                
            }).catch((error) => { 
                  console.log('Conflict error:', error.response);
               
            });

        }
      };
    
    handleChange = (event) => {
        const { name, value, files } = event.target; 

        if (name === 'file') {
            this.setState({ file: files[0] });
          } else {
            this.setState({ [name]: value });
          }
      };
 
    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
            <div class="contact-area item-flex default-padding">
        <div class="container">
            <div class="row">
                <div class="col-2">

                </div>
                <div class="col-md-6 contact-items">
                    <div class="heading">
                        <h2>Apply Now</h2> 
                    </div>
                    <form action="" method="POST" class="contact-form" encType="multipart/form-data">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="form-group">
                                    <input class="form-control" id="name" name="name" placeholder="Name*" type="text" onChange={this.handleChange} value={this.state.name}  />
                                    <span class="alert-error">{this.state.errors.name && <label className="error">{this.state.errors.name}</label>}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input class="form-control" id="email" name="email" placeholder="Email*" type="email"  onChange={this.handleChange} value={this.state.email}  />
                                    <span class="alert-error">{this.state.errors.email && <label className="error">{this.state.errors.email}</label>}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input class="form-control" id="phone" name="phone" placeholder="Phone Number*" type="text"  onChange={this.handleChange} value={this.state.phone}  />
                                    <span class="alert-error">{this.state.errors.phone && <label className="error">{this.state.errors.phone}</label>}</span>
                                </div>
                            </div>
                        </div> 
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input class="form-control" id="city" name="city" placeholder="City" type="text"  onChange={this.handleChange} value={this.state.city}  />
                                    <span class="alert-error">{this.state.errors.city && <label className="error">{this.state.errors.city}</label>}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input class="form-control" key={this.state.fileKey} id="file" name="file" placeholder="CV" type="file"  onChange={this.handleChange} accept='application/*'  />
                                    <span class="alert-error">{this.state.errors.file && <label className="error">{this.state.errors.file}</label>}</span>
                                </div>
                            </div>
                        </div> 
                        <div class="col-md-12">
                            <div class="row">
                                <button type="submit" name="submit" id="submit"   onClick={this.handleSubmit}>
                                    Apply Now<i class="fa fa-paper-plane"></i>
                                </button>
                                <div id={this.state.sending ? "dblock" : "dnone"}> <img src={base_url+"assets/img/loader.gif"} className="Loader" alt="Loader" /></div>
                            </div>
                        </div>
                       
                        <div class="col-md-12 alert-notification">
                            <div id="message" class="alert-msg">
                                 
                            <div className='alert alert-success '  id={this.state.fopen ? "dblock" : "dnone"}>{this.state.success_message}</div>
                        
                        <div className='alert alert-warning '  id={this.state.reg_error ? "dblock" : "dnone"}>{this.state.err_message}</div>
    
                            </div>
                        </div>
                    </form>
                    
                </div>
            </div>
        </div>

        </div>
       
</div>
    );
 
    }
}

export default ApplyNowContent;